import { styled, Typography } from '@mui/material';
import { SwiperSlide } from 'swiper/react';

export const NoBeneficiariesLabelStyled = styled(Typography)(({ theme }) => ({
  margin: 'auto 0',
  color: theme.palette.grey[400],
}));

export const SwiperSlideStyled = styled(SwiperSlide)(({ theme }) => ({
  paddingBottom: theme.spacing(6),
})) as typeof SwiperSlide;
